<template>
  <div class=" ">
    <div class="pt-5 d-none d-md-block">
      <div class="pl-sm-5 text-body-1 text-sm-h6 text-uppercase black--text">
        Kategori
      </div>
    </div>
    <div class="pt-4 pb-5">
      <carousel
        :loop="false"
        :nav="false"
        :dots="false"
        :margin="10"
        :responsive="{
          0: { items: 5, nav: false },
          600: { items: 6, nav: false },
          1000: { items: 5 },
          1300: { items: 6 },
        }"
        v-if="category.length > 0"
      >
        <div
          v-for="index in Math.ceil(categoryPagination.total_data / 2)"
          :key="index"
        >
          <!-- <v-card
            outlined
            class="product-category rounded-lg text-body-2"
            height="75"
            v-if="category[(index - 1) * 2]"
          >
            <router-link
              :to="{
                name: 'search',
                query: {
                  category:
                    category[
                      (index - 1) * 2
                    ].product_category_slug.toLowerCase(),
                  type: 'product',
                },
              }"
              text
              class="text-deco"
            >
              <v-row class="pl-3 d-flex align-center">
                <v-col cols="4" class="py-0 d-flex align-center">
                  <v-img
                    :src="category[(index - 1) * 2].product_category_image"
                  ></v-img>
                </v-col>
                <v-col cols="8" class="py-0 d-flex align-center">
                  <div class="text-capitalize black--text category-title">
                    {{ category[(index - 1) * 2].product_category_name }}
                  </div>
                </v-col>
              </v-row>
            </router-link>
          </v-card> -->
          <category-card
            v-if="category[(index - 1) * 2]"
            :data="category[(index - 1) * 2]"
          />
          <category-card
            v-if="category[(index - 1) * 2 + 1]"
            :data="category[(index - 1) * 2 + 1]"
          />
          <!-- <v-card
            outlined
            class="product-category mt-3 rounded-lg text-body-2"
            height="75"
            v-if="category[(index - 1) * 2 + 1]"
          >
            <router-link
              :to="{
                name: 'search',
                query: {
                  category:
                    category[
                      (index - 1) * 2 + 1
                    ].product_category_slug.toLowerCase(),
                  type: 'product',
                },
              }"
              text
              class="text-deco"
            >
              <v-row class="pl-3 d-flex align-center ">
                <v-col cols="4" class="py-0 ">
                  <v-img
                    :src="category[(index - 1) * 2 + 1].product_category_image"
                  ></v-img>
                </v-col>
                <v-col cols="8" class="py-0 ">
                  <div
                    class="text-capitalize black--text category-title text-elipsis"
                  >
                    {{ category[(index - 1) * 2 + 1].product_category_name }}
                  </div>
                </v-col>
              </v-row>
            </router-link>
          </v-card> -->
        </div>
        <template slot="prev">
          <v-card elevation="0" class="col-12 pa-0" v-if="category.length > 12">
            <v-btn
              x-small
              color="white"
              elevation="3"
              fab
              class="prev prev-category"
            >
              <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
            </v-btn>
          </v-card>
        </template>
        <template slot="next">
          <v-card elevation="0" class="col-12 pa-0" v-if="category.length > 12">
            <v-btn
              x-small
              color="white"
              elevation="3"
              fab
              class="next next-category"
            >
              <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
            </v-btn>
          </v-card>
        </template>
      </carousel>
      <v-card v-else> No Category... </v-card>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import { mapState, mapActions } from "vuex";
import categoryCardVue from "./categoryCard.vue";
export default {
  components: {
    carousel,
    "category-card": categoryCardVue,
  },
  computed: {
    ...mapState("category", ["category", "categoryPagination"]),
  },
  created() {
    this.getCategory({ limit: 24 });
  },
  methods: {
    ...mapActions("category", ["getCategory"]),
  },
};
</script>

<style lang="scss" scoped>
.text-elipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
